import { useTu } from "@src/appV2/i18n/useTu";
import { Box, Stack, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";
import { Text } from "../../components/Text";
import type { AdminChatMessage } from "../types";
import { parseCustomMessage } from "../utils/parseCustomMessage";

interface PlacementApplicationInviteProps {
  message: AdminChatMessage;
  sx?: SxProps<Theme>;
}

export function PlacementApplicationInvite(props: PlacementApplicationInviteProps) {
  const { tu } = useTu("chat");

  const { message, sx } = props;
  const displayMessage = parseCustomMessage(message.message);

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "flex",
          justifyContent: "center",
          padding: 2,
        },
        sx
      )}
    >
      <Stack spacing={1} sx={{ maxWidth: "80%", textAlign: "center" }}>
        <Text
          variant="caption"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            fontStyle: "italic",
          })}
        >
          {tu("This is an automated message sent on behalf of your facility")}
        </Text>
        <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.primary })}>
          {displayMessage}
        </Text>
      </Stack>
    </Box>
  );
}
